import React from "react";

const ConfirmTransactionModal = ({
  isOpen,
  onClose,
  onConfirm,
  transactionId,
  itemName,
  isLoading = false,
  errorText = null,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-[12px] p-5 md:p-8 max-w-[625px] w-full mx-4">
        {/* Header */}
        <h3 className="text-page-title md:text-page-title-d font-rubik text-[#1E1E1E] mb-4">
          Confirm transaction
        </h3>

        {/* Content */}
        <div className="mb-8 text-page-subtitle-d font-normal opacity-50">
          <p className="text-[#1E1E1E] mb-4 leading-relaxed">
            Are you sure you want to confirm transaction of the{" "}
            <span className="italic">"{itemName}"</span>?
          </p>
          <p className="text-[#1E1E1E]">This action cannot be undone.</p>
        </div>

        {errorText && (
          <div className="mb-6 rounded-[8px] border border-red-200 bg-red-50 px-4 py-3">
            <p className="text-sm text-red-700">{errorText}</p>
          </div>
        )}

        {/* Actions */}
        <div className="flex flex-col md:flex-row gap-4 justify-end">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-3 order-2 md:order-1 text-esblue min-w-[147px] rounded-[8px] bg-[#F5F8FF] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-3 order-1 md:order-2 bg-[#B9FFCC] min-w-[147px] text-[#16653F] text-nav-d rounded-[8px] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Confirming..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmTransactionModal;
